import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Form, FormGroup, Input } from "reactstrap";
import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";
import "../styles/contact.css";

const socialLinks = [
  {
    url: "https://www.facebook.com/profile.php?id=100089234877784",
    icon: "ri-facebook-line",
    label: "Facebook",
  },
  {
    url: "https://www.instagram.com/",
    icon: "ri-instagram-line",
    label: "Instagram",
  },
];

const Contact = () => {
  return (
    <Helmet title="Contact">
      <CommonSection title="Contact" />
      <section className="contact-section">
        <Container>
          <Row className="g-4 align-items-start">
            <Col lg="7" md="12">
              <div className="contact-card">
                <h4 className="contact-title">Trimite-ne un mesaj</h4>
                <p className="contact-subtitle">Suntem disponibili pentru orice întrebare despre mașini, finanțare sau livrare.</p>

                <Form>
                  <FormGroup className="contact__form">
                    <Input placeholder="Numele tău" type="text" />
                  </FormGroup>
                  <FormGroup className="contact__form">
                    <Input placeholder="Email" type="email" />
                  </FormGroup>
                  <FormGroup className="contact__form">
                    <textarea
                      rows="5"
                      placeholder="Mesaj"
                      className="textarea"
                    ></textarea>
                  </FormGroup>

                  <button className="contact__btn" type="submit">
                    Trimite mesaj
                  </button>
                </Form>
              </div>
            </Col>

            <Col lg="5" md="12">
              <div className="contact-card contact-info-card">
                <h4 className="contact-title">Informații contact</h4>

                <div className="contact-item">
                  <h6>Adresă</h6>
                  <p>Arad, Buteni, Strada Orizontului, nr.55</p>
                </div>

                <div className="contact-item">
                  <h6>Telefon</h6>
                  <p>
                    <a href="tel:+40741383836">0741.383.836</a>
                  </p>
                </div>

                <div className="contact-item">
                  <h6>Email</h6>
                  <p>matsellauto@gmail.com</p>
                </div>

                <div className="contact-socials">
                  <h6>Ne găsești și pe:</h6>
                  <div className="social-links">
                    {socialLinks.map((item) => (
                      <Link
                        to={item.url}
                        key={item.label}
                        className="social__link-icon"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className={item.icon} aria-hidden="true"></i>
                        <span>{item.label}</span>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default Contact;
